import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { industriesData } from "@/data/industriesData";
import { industryTranslations } from "@/data/industriesTranslations";
import { useLanguage } from "@/contexts/LanguageContext";

const Industries = () => {
  const { language, t, getLocalizedPath } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 py-12">
        <div className="container mx-auto px-4">
          <div className="mb-12 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">{t("industries.pageTitle")}</h1>
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto">{t("industries.pageSubtitle")}</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {industriesData.map((industry, index) => {
              const Icon = industry.icon;
              const trans = industryTranslations[industry.slug]?.[language] || industryTranslations[industry.slug]?.en;
              return (
                <Link key={index} to={getLocalizedPath(`industries/${industry.slug}`)} className="group">
                  <div className="bg-secondary rounded-lg p-6 transition-all hover:shadow-lg hover:scale-[1.02] h-full">
                    <div className="flex items-center space-x-4 mb-4">
                      <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                        <Icon className="h-6 w-6 text-primary" />
                      </div>
                      <h2 className="text-xl font-bold group-hover:text-primary transition-colors">{trans?.title || industry.slug}</h2>
                    </div>
                    <p className="text-muted-foreground mb-4">{trans?.description || ''}</p>
                    <div className="text-sm text-primary font-medium group-hover:underline">{t("industries.viewDetails")} →</div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Industries;
